<template>
  <el-menu :default-active="this.$route.path" :router="true">
    <el-menu-item index="/user/me">
      <i class="el-icon-user"></i>
      我的话题
    </el-menu-item>
    <el-menu-item index="/user/settings">
      <i class="el-icon-collection-tag"></i>
      订阅标签
    </el-menu-item>
    <el-menu-item index="/notifications/replies">
      <el-badge
        :value="user.notification_count > 0 ? user.notification_count : ''"
        :max="100"
      >
        <i class="el-icon-message"></i>
        我的通知
      </el-badge>
    </el-menu-item>
    <el-menu-item :index="'/messages'">
      <el-badge
        :value="user.message_count > 0 ? user.message_count : ''"
        :max="100"
      >
        <i class="el-icon-chat-dot-round"></i>
        私信消息
      </el-badge>
    </el-menu-item>
    <el-menu-item index="/user/edit">
      <i class="el-icon-edit"></i>
      个人资料
    </el-menu-item>
    <el-menu-item index="/user/profile">
      <i class="el-icon-link"></i>
      个人主页
    </el-menu-item>
    <el-menu-item index="/user/subscription">
      <i class="el-icon-bank-card"></i>
      会员信息
    </el-menu-item>
  </el-menu>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["user"])
  }
};
</script>
